import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGreenArrowUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.99992 12.6666V3.33331M7.99992 3.33331L3.33325 7.99998M7.99992 3.33331L12.6666 7.99998",
		stroke: "#118A5D",
		strokeWidth: 1.6,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgGreenArrowUp;
